<template>
  <div id="modemHistoryPopup">
    <div class="common_view_head">
      <div><span>구분</span></div>
      <div><span>등록자</span></div>
      <div><span>등록일자</span></div>
      <div><span>내용</span></div>
    </div>
    <div class="common_view_list">
      <div v-if="historyList.length <= 0">이력 없음</div>
      <div class="common_view_item" :key="`history_${index}`" v-for="(item, index) in historyList">
        <div>
          <div>
            <span v-if="item.type === 'as'">
              <template v-if="item.step === 2">모뎀 A/S 요청완료</template>
              <template v-else-if="item.step === 3">모뎀 A/S 접수완료</template>
              <template v-else-if="item.step === 4">모뎀 A/S 처리완료</template>
              <template v-else>-</template>
            </span>
            <span v-else-if="item.type === 'sq'">
              <template v-if="item.step === 2">음영∙품질 개선 보류</template>
              <template v-else-if="item.step === 3">음영∙품질 개선 요청완료</template>
              <template v-else-if="item.step === 4">음영∙품질 개선 접수완료</template>
              <template v-else-if="item.step === 5">음영∙품질 개선 처리완료</template>
              <template v-else>-</template>
            </span>
            <span v-else-if="item.type === 'stop'">
              <template v-if="item.step === 2">정지 요청완료</template>
              <template v-else-if="item.step === 3">정지 처리완료</template>
              <template v-else>-</template>
            </span>
            <span v-else-if="item.type === 'cancel'">
              <template v-if="item.step === 2">정지해제 요청완료</template>
              <template v-else-if="item.step === 3">정지해제 처리완료</template>
              <template v-else>-</template>
            </span>
            <span v-else>-</span>
          </div>
          <div><span class="link fc_primary_blue" @click="showDetail(item, 'U')">{{item.userName}}</span></div>
          <div><span>{{item.regDate}}</span></div>
          <div><span class="link fc_primary_blue" @click="showDetail(item, 'D')">[상세보기]</span></div>
        </div>
        <div v-if="item.isLink1">
          <div>
            작성자 : {{item.userName}} <span>|</span> 소속 :
            <template v-if="item.affiliateCode != null">
              <template v-for="afc in afcList" v-if="afc.codeValue === item.affiliateCode">{{afc.codeName}}</template>
            </template>
            <template v-if="item.officeCode != null">
              <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === item.officeCode.substring(0, 5)">{{ofc1.codeName}}</template>
              <template v-if="item.officeCode.length > 5">
                <template v-for="ofc2 in ofc2List" v-if="ofc2.codeValue === item.officeCode">{{ofc2.codeName}}</template>
              </template>
            </template>
            <template v-if="item.chargeCode != null">
              <template v-for="rwk in rwkList" v-if="rwk.codeValue === item.chargeCode">{{rwk.codeName}}</template>
            </template>
          </div>
          <div>전화번호 : {{item.telephone}}<span> | </span>휴대전화 : {{item.mobilePhone}}</div>
        </div>
        <div v-if="item.isLink2">
          <div>
            상세보기<br>
            <template v-if="item.type === 'as'">
              <template v-if="item.step === 2">요청사항: {{item.requestIssue}}</template>
              <template v-if="item.step >= 3">처리사항: {{item.asDesc}}</template>
            </template>
            <template v-else-if="item.type === 'sq'">
              <template v-if="item.step === 2">보류사유: {{item.holdDesc}}</template>
              <template v-else-if="item.step === 3">
                <br>
                모뎀정보<br>
                <br>
                모델명: {{item.modelName}}<br>
                모델번호: {{item.serialNum}}<br>
                기기번호(계량기 번호): {{item.meterNum}}<br>
                요청구분:
                <template v-if="item.requestType != null">
                  <template v-for="rqt in srtList" v-if="item.requestType === rqt.codeValue">{{rqt.codeName}}</template>
                </template>
                <template v-else>-</template>
                <br>
                현장담당자(이름): {{item.siteMngName}}<br>
                현장담당자 연락처: {{item.siteMngContract}}<br>
                도로명 주소: ({{item.postalCode}}) {{item.addressRoad}} {{item.addressDetails}}<br>
                지번 주소: ({{item.postalCode}}) {{item.addressRoad}} {{item.addressDetails}}<br>
                상호/건물명: {{item.buildingName}}<br>
                모뎀위치: 옥내<br>
                수신레벨:
                <template v-if="item.signalLevel != null">
                  <template v-for="sgl in signalLevelList" v-if="item.signalLevel === sgl.codeValue">{{sgl.codeName}}dbm</template>
                </template>
                <template v-else>-</template>
                <br>
                계량기 상세 위치: {{item.meterPos}}<br>
                건물주/담당자 특이사항: {{item.ownerMemo}}<br>
                건물 담당자 연락처: {{item.ownerContact}}<br>
                문제점 및 현상:
                <template v-if="item.issueCode != null">
                  <template v-for="pbt in iscList" v-if="item.issueCode === pbt.codeValue">{{pbt.codeName}}</template>
                </template>
                <template v-else>-</template>
                <br>
                기타사항: {{item.etcMemo}}
              </template>
              <template v-else-if="item.step >= 4">
                처리날짜: {{item.procDate}}<br>
                조치내역:
                <template v-for="act in actList" v-if="act.codeValue === item.action">{{act.codeName}}</template>
                <br>
                조치기타내용: {{item.actionDesc}}
              </template>
            </template>
            <template v-else>정보없음</template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modemInfo from '../../script/modemInfo'
import common from '../../script/common'
import modemAS from '../../script/modemAS'
import shadowQuality from '../../script/shadowQuality'

export default {
  props: ['popupParams'],
  data () {
    return {
      // Common Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      ofc2List: [],
      rwkList: [],
      srtList: [],
      signalLevelList: common.getSQSignalLevelList(),
      iscList: [],
      actList: [],
      // Data
      selectedModem: {},
      historyList: []
    }
  },
  mounted () {
    this.selectedModem = this.popupParams.data
    let intervalCnt = 0
    let interval = setInterval(() => {
      if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
        common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
        common.checkValidateData('session', sessionStorage.getItem('rwkList')) &&
        common.checkValidateData('session', sessionStorage.getItem('srtList')) &&
        common.checkValidateData('session', sessionStorage.getItem('iscList')) &&
        common.checkValidateData('session', sessionStorage.getItem('actList'))) {
        clearInterval(interval)
        this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
        this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
        this.ofc1List = this.getOfc1List()
        this.ofc2List = this.getOfc2List()
        this.rwkList = JSON.parse(sessionStorage.getItem('rwkList'))
        this.srtList = JSON.parse(sessionStorage.getItem('srtList'))
        this.iscList = JSON.parse(sessionStorage.getItem('iscList'))
        this.actList = JSON.parse(sessionStorage.getItem('actList'))
        this.getModemInfoHistory()
      } else if (intervalCnt > 10) {
        clearInterval(interval)
        common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
      } else {
        intervalCnt++
      }
    }, 200)
  },
  methods: {
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    getOfc2List () {
      return this.ofcList.filter(item => { return item.codeLevel === 1 })
    },
    getModemInfoHistory () {
      modemInfo.getModemInfoHistory({
        modemPid: this.selectedModem.modemPid
      }, response => {
        console.log('모뎀 기기이력', response)
        if (response.data.resultCode === 1) {
          let list = response.data.result.body
          list = list.filter(item => { return item.step !== 1 }) // 요청 제외
          list = list.filter(item => { return (item.type === 'as' && item.step !== 5) || (item.type === 'sq' && item.step !== 6) || ((item.type === 'stop' || item.type === 'cancel') && item.step !== 4) }) // 처리확인 제외
          for (let i = 0; i < list.length; i++) {
            list[i].isLink1 = false
            list[i].isLink2 = false
            if (list[i].type === 'as') {
              if (list[i].step === 2) {
                list[i].requestIssue = ''
              } else if (list[i].step >= 3) {
                list[i].asDesc = ''
              }
            } else if (list[i].type === 'sq') {
              list[i].modelName = ''
              list[i].serialNum = ''
              list[i].meterNum = ''
              list[i].requestType = ''
              list[i].siteMngName = ''
              list[i].siteMngContract = ''
              list[i].postalCode = ''
              list[i].addressRoad = ''
              list[i].addressLot = ''
              list[i].addressDetails = ''
              list[i].buildingName = ''
              list[i].modemPos = ''
              list[i].signalLevel = ''
              list[i].meterPos = ''
              list[i].ownerMemo = ''
              list[i].ownerContact = ''
              list[i].issueCode = ''
              list[i].etcMemo = ''
              if (list[i].step === 2) {
                list[i].holdDesc = ''
              } else if (list[i].step === 3) {
                list[i].issueCode = ''
              } else if (list[i].step >= 4) {
                list[i].procDate = ''
                list[i].action = ''
                list[i].actionDesc = ''
              }
            }
          }
          this.historyList = list
        } else {
          common.amsAlert('retry', '모뎀이력을 불러오지 못했습니다.')
        }
      })
    },
    showDetail (item, type) {
      if (type === 'U') {
        item.isLink1 = !item.isLink1
        item.isLink2 = false
      } else if (type === 'D') {
        if (item.type === 'as') {
          modemAS.getModemAS({
            asPid: item.orgPid
          }, response => {
            console.log('getModemAS', response)
            if (response.data.resultCode === 1) {
              if (item.step === 2) {
                item.requestIssue = response.data.result.body.requestIssue
              } else if (item.step >= 3) {
                item.asDesc = response.data.result.body.asDesc
              }
            }
          })
        } else if (item.type === 'sq') {
          shadowQuality.getQuality({
            sqPid: item.orgPid
          }, response => {
            console.log('getQuality', response)
            if (response.data.resultCode === 1) {
              const data = response.data.result.body
              item.modelName = data.modelName != null ? data.modelName : ''
              item.serialNum = data.serialNum != null ? data.serialNum : ''
              item.meterNum = data.meterNum != null ? data.meterNum : ''
              item.requestType = data.requestType != null ? data.requestType : ''
              item.siteMngName = data.siteMngName != null ? data.siteMngName : ''
              item.siteMngContract = data.siteMngContract != null ? data.siteMngContract : ''
              item.postalCode = data.postalCode != null ? data.postalCode : ''
              item.addressRoad = data.addressRoad != null ? data.addressRoad : ''
              item.addressLot = data.addressLot != null ? data.addressLot : ''
              item.addressDetails = data.addressDetails != null ? data.addressDetails : ''
              item.buildingName = data.buildingName != null ? data.buildingName : ''
              item.modemPos = data.modemPos != null ? data.modemPos : ''
              item.signalLevel = data.signalLevel != null ? data.signalLevel : ''
              item.meterPos = data.meterPos != null ? data.meterPos : ''
              item.ownerMemo = data.ownerMemo != null ? data.ownerMemo : ''
              item.ownerContact = data.ownerContact != null ? data.ownerContact : ''
              item.issueCode = data.issueCode != null ? data.issueCode : ''
              item.etcMemo = data.etcMemo != null ? data.etcMemo : ''
              if (item.step === 2) {
                item.holdDesc = data.holdDesc
              } else if (item.step === 3) {
                item.issueCode = data.issueCode
              } else if (item.step >= 4) {
                item.procDate = common.getFormattedDate(data.procDate)
                item.action = data.action
                item.actionDesc = data.actionDesc
              }
            }
          })
        }
        item.isLink1 = false
        item.isLink2 = !item.isLink2
      } else {
        item.isLink1 = false
        item.isLink2 = false
      }
      console.log(item)
    }
  }
}
</script>

<style scoped>
#modemHistoryPopup .common_view_head > div {
  display: flex;
  height: 50px;
  padding: 0;
}

#modemHistoryPopup .common_view_head > div > span {
  margin: auto;
}

#modemHistoryPopup .common_view_head > div:nth-child(1) {
  width: 40%;
}

#modemHistoryPopup .common_view_head > div:nth-child(2) {
  width: 20%;
}

#modemHistoryPopup .common_view_head > div:nth-child(3) {
  width: 20%;
}

#modemHistoryPopup .common_view_head > div:nth-child(4) {
  width: 20%;
}

#modemHistoryPopup .common_view_list > .common_view_item > div:nth-child(1) > div {
  display: flex;
  height: 50px;
  padding: 0;
}

#modemHistoryPopup .common_view_list > .common_view_item > div:nth-child(1) > div > span {
  margin: auto;
}

#modemHistoryPopup .common_view_list > .common_view_item > div:nth-child(1) > div:nth-child(1) {
  width: 40%;
  font-weight: 700;
}

#modemHistoryPopup .common_view_list > .common_view_item > div:nth-child(1) > div:nth-child(2) {
  width: 20%;
  font-weight: 700;
}

#modemHistoryPopup .common_view_list > .common_view_item > div:nth-child(1) > div:nth-child(3) {
  width: 20%;
  font-weight: 400;
}

#modemHistoryPopup .common_view_list > .common_view_item > div:nth-child(1) > div:nth-child(4) {
  width: 20%;
  font-weight: 700;
}

#modemHistoryPopup .common_view_list > .common_view_item > div > div {
  width: 100%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/modemInfo/ModemHistoryPopup.vue